import { inject, Injectable } from '@angular/core';
import { BaseService } from '@shared/core';
import { IBaseValueModel, IZoneFilterModel, IZoneModel, IZoneResponseModel } from '@pkp-g/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ZonesApiService {
  private http = inject(BaseService);
  apiUrl = 'v1/zones';

  getAllZones(filter?: IZoneFilterModel): Observable<IZoneResponseModel> {
    return this.http.get<IZoneResponseModel>(`${this.apiUrl}`, filter);
  }

  getZoneById(id?: string): Observable<{ zone: IZoneModel }> {
    return this.http.get<{ zone: IZoneModel }>(`${this.apiUrl}/${id}`);
  }

  createZone(zone: IZoneModel): Observable<{ uuid: IBaseValueModel }> {
    return this.http.post<{ uuid: IBaseValueModel }>(`${this.apiUrl}`, zone);
  }

  editZone(zone: IZoneModel, id?: string): Observable<{ uuid: IBaseValueModel }> {
    return this.http.put<{ uuid: IBaseValueModel }>(`${this.apiUrl}/${id}`, zone);
  }

  deleteZone(id: string): Observable<unknown> {
    return this.http.delete<unknown>(`${this.apiUrl}/${id}`);
  }
}
